module.exports = __webpack_public_path__ + "static/media/instagram-gray-sm.ff8319a4.svg";